export default __webpack_public_path__ + "static/media/contact.fb04464f.png";